import { useMemo } from "react";
import CartApi from "./cartApi";
import useSessionId from "./useSessionId";

function useCartApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new CartApi(sessionId), [sessionId]);
}

export default useCartApi;
